
import { Box, Typography } from '@mui/material'
import React from 'react'
import './SkillCard.css';
const SkillCard = (props) => {
  return (
    <Box className="card">
        <Box sx={{width:'100%', textAlign:'center'}}>
        <img src={props.item.link} alt={props.item.name} />
        </Box>
        <Box sx={{width:'100%', textAlign:'center'}}  marginTop={'10px'}>
        <Typography variant='body' color={'#F2F2F2'}>{props.item.name}</Typography>
        </Box>
    </Box>
  )
}

export default SkillCard